// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root Variables - Your Color Scheme */
:root {
  --primary: #373334;      /* Dark tone for text/backgrounds */
  --accent: #62b58f;       /* Green accent for buttons/highlights */
  --light-bg: #f8f9fa;     /* Light background */
  --white: #ffffff;        /* Pure white */
  --gray: #6c757d;         /* Medium gray */
  --light-gray: #e9ecef;   /* Light gray */
  --border: #dee2e6;       /* Border color */
  --error: #dc3545;        /* Red for errors */
  --success: #28a745;      /* Green for success */
}

/* Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Montserrat', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: var(--primary);
  background-color: var(--white);
  min-height: 100vh;
}

/* Container */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Header */
.header {
  background-color: var(--primary);
  padding: 1rem 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo a {
  color: var(--accent);
  font-size: 1.8rem;
  font-weight: bold;
  text-decoration: none;
}

.nav {
  display: flex;
  gap: 2rem;
}

.nav a {
  color: var(--white); /* Ensure nav text is white for visibility on dark bg */
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.nav a:hover,
.nav a.active {
  color: var(--accent);
}

.nav-link {
  color: var(--white);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.nav-link:hover,
.nav-link.active {
  color: var(--accent);
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--white);
  font-size: 1.5rem;
}

/* Main Content */
.main-content {
  min-height: calc(100vh - 140px);
}

/* Footer */
.footer {
  background-color: var(--primary);
  color: var(--white);
  text-align: center;
  padding: 1.5rem 0;
  margin-top: 2rem;
}

/* Pages */
.page {
  padding: 2rem 0;
}

/* === HOME PAGE ENHANCEMENTS === */

/* Base Section Styling */
.home-page section {
  padding: 5rem 0;
  position: relative;
}

/* Alternating Background Colors */
.home-page .hero {
  background: linear-gradient(to right, var(--primary), var(--accent));
  color: var(--white);
  text-align: center;
}

.home-page .services,
.home-page .testimonials,
.home-page .comparison,
.home-page .trust {
  background-color: var(--white);
}

.home-page .why-choose,
.home-page .how-works,
.home-page .integrations,
.home-page .faq {
  background-color: var(--light-bg);
}

.home-page .cta {
  background: linear-gradient(135deg, var(--accent) 0%, #4a9c7a 100%);
  color: var(--white);
  text-align: center;
}

/* Section Borders */
.home-page .services,
.home-page .why-choose,
.home-page .how-works,
.home-page .testimonials,
.home-page .faq,
.home-page .comparison,
.home-page .integrations,
.home-page .trust {
  border-bottom: 1px solid rgba(0,0,0,0.08);
}

/* Hero Section */
.hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.hero-content h1 {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  font-weight: 700;
}

.hero-content p {
  font-size: 1.3rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.hero-image {
  max-width: 600px;
  width: 100%;
  height: auto;
  border-radius: 12px;
  margin: 2rem auto;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}

/* Services Grid */
.services .grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.service-item {
  text-align: center;
  padding: 2rem 1.5rem;
  background: var(--white);
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(0,0,0,0.05);
}

.service-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.15);
}

.service-item svg {
  margin-bottom: 1rem;
}

.service-item h3 {
  color: var(--primary);
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.service-item p {
  color: var(--gray);
  line-height: 1.6;
}

/* Why Choose Grid */
.why-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2.5rem;
  margin-top: 3rem;
}

.why-item {
  text-align: center;
  padding: 2rem;
}

.why-item svg {
  margin-bottom: 1.5rem;
}

.why-item h3 {
  color: var(--primary);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.why-item p {
  color: var(--gray);
  line-height: 1.6;
}

/* How It Works Steps */
.steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 3rem;
  margin-top: 3rem;
}

.step {
  text-align: center;
  position: relative;
}

.step span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: var(--accent);
  color: var(--white);
  border-radius: 50%;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
}

.step h3 {
  color: var(--primary);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.step p {
  color: var(--gray);
  line-height: 1.6;
}

/* Testimonials */
.testimonial-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.quote {
  background: var(--white);
  padding: 2rem;
  border-radius: 12px;
  border-left: 4px solid var(--accent);
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  font-style: italic;
  color: var(--primary);
  line-height: 1.6;
}

/* FAQ */
.faq-item {
  background: var(--white);
  margin-bottom: 1rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.faq-item:hover {
  border-color: var(--accent);
}

.faq-item h3 {
  padding: 1.5rem;
  margin: 0;
  color: var(--primary);
  font-size: 1.1rem;
  position: relative;
}

.faq-item h3::after {
  content: '+';
  position: absolute;
  right: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.5rem;
  color: var(--accent);
}

.faq-item p {
  padding: 0 1.5rem 1.5rem;
  margin: 0;
  color: var(--gray);
  line-height: 1.6;
  border-top: 1px solid var(--border);
  padding-top: 1rem;
}

/* Comparison Table */
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 2rem;
  background: var(--white);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
}

th, td {
  padding: 1.2rem 1.5rem;
  text-align: left;
  border-bottom: 1px solid var(--border);
}

th {
  background: var(--accent);
  color: var(--white);
  font-weight: 600;
}

tr:last-child td {
  border-bottom: none;
}

/* Integrations & Trust */
.logo-grid, .badge-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
  align-items: center;
}

.partner-logo {
  max-width: 120px;
  height: auto;
  opacity: 0.8;
  transition: opacity 0.3s ease;
  justify-self: center;
}

.partner-logo:hover {
  opacity: 1;
}

/* CTA Section */
.cta-button {
  display: inline-block;
  background: var(--white);
  color: var(--accent);
  padding: 1rem 2.5rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  margin-top: 2rem;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.3);
}

/* Forms */
.zip-search-form, .state-zip-search-form {
  max-width: 600px;
  margin: 0 auto 2rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-group input, .form-group textarea, .form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 1rem;
  background: var(--white);
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.form-group input:focus, .form-group textarea:focus, .form-group select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(98, 181, 143, 0.2);
}

.form-group label {
  font-weight: 600;
  margin-bottom: 0.5rem;
  display: block;
  color: var(--primary);
}

.zip-input {
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
}

.radio-group {
  display: flex;
  gap: 2rem;
  margin-top: 0.5rem;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  background: var(--light-bg);
  padding: 0.75rem 1.5rem;
  border-radius: 5px;
  transition: background 0.3s;
}

.radio-label:hover {
  background: rgba(98,181,143,0.1);
}

.search-btn, .submit-btn {
  background-color: var(--accent);
  color: var(--white);
  border: none;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 100%;
  margin-top: 1rem;
}

.search-btn:hover, .submit-btn:hover {
  background-color: #4a9c7a;
}

.search-btn:disabled, .submit-btn:disabled {
  background-color: var(--gray);
  cursor: not-allowed;
}

/* Bookkeeper Cards */
.bookkeeper-card {
  background: var(--white);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--border);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.bookkeeper-card h3 {
  color: var(--primary);
  margin-bottom: 1rem;
}

.bookkeeper-card p {
  margin-bottom: 0.5rem;
}

.preferred-contact {
  padding-top: 0.5rem;
  border-top: 1px solid var(--light-gray);
  margin-top: 0.5rem;
}

/* Contact Form */
.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: start;
}

.contact-info h2 {
  margin-bottom: 1rem;
  color: var(--primary);
}

/* Messages */
.submit-message {
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.submit-message.success {
  background-color: #d4edda;
  color: var(--success);
  border: 1px solid #c3e6cb;
}

.submit-message.error {
  background-color: #f8d7da;
  color: var(--error);
  border: 1px solid #f5c6cb;
}

.loading {
  text-align: center;
  padding: 2rem;
  font-size: 1.1rem;
  color: var(--gray);
}

.error-message {
  background-color: #f8d7da;
  color: var(--error);
  padding: 1rem;
  border-radius: 4px;
  margin: 1rem 0;
  border: 1px solid #f5c6cb;
}

.no-results {
  text-align: center;
  padding: 3rem;
  color: var(--gray);
}

/* State Zip Search Form */
.zip-group {
  margin-bottom: 2rem;
}

.zip-header {
  background-color: var(--accent);
  color: var(--white);
  padding: 0.5rem 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.bookkeepers-in-zip {
  display: grid;
  gap: 1rem;
}

/* Section Headers */
.services h2, .why-choose h2, .how-works h2, .testimonials h2, .faq h2, .comparison h2, .integrations h2, .trust h2, .cta h2 {
  font-size: 2.5rem;
  color: var(--primary);
  text-align: center;
  margin-bottom: 2rem;
}

.cta h2 {
  color: var(--white);
}

/* Responsive Design */
@media (max-width: 768px) {
  .container {
    padding: 15px;
  }

  /* Header */
  .nav {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background-color: var(--primary);
    padding: 20px;
    gap: 1rem;
  }
  
  .nav.open {
    display: flex;
  }
  
  .menu-toggle {
    display: block;
  }

  .header .container {
    flex-direction: column;
    gap: 1rem;
  }

  /* Home Sections */
  .home-page section {
    padding: 3rem 0;
  }
  
  .hero-content h1 {
    font-size: 2.2rem;
  }
  
  .services .grid,
  .why-grid,
  .steps,
  .testimonial-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .logo-grid, .badge-grid {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 1.5rem;
  }

  /* Forms */
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .form-group input, .form-group textarea, .form-group select {
    font-size: 1.1rem;
    padding: 1.2rem;
  }
  
  .submit-btn, .search-btn {
    padding: 1.2rem;
    font-size: 1.1rem;
  }
  
  .radio-group {
    flex-direction: column;
    gap: 1rem;
  }

  .contact-content {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 769px) {
  .menu-toggle {
    display: none;
  }
}
/* === LISTING PAGE STYLES === */

.listing .hero-section {
  text-align: center;
  padding: 2rem 0 3rem;
}

.listing .hero-section h1 {
  color: var(--primary);
  margin-bottom: 1rem;
  font-size: 2.5rem;
}

.listing .hero-subtitle {
  font-size: 1.2rem;
  color: var(--gray);
  max-width: 600px;
  margin: 0 auto;
}

.zip-search-form {
  max-width: 600px;
  margin: 0 auto 3rem;
  padding: 2rem;
  background: var(--light-bg);
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.listing .form-row {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
}

.listing .form-row .form-group {
  flex: 1 1;
  margin-bottom: 0;
}

.listing .zip-input {
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  height: 54px; /* Match button height */
}

.listing .submit-btn {
  height: 54px; /* Match input height */
  white-space: nowrap;
  margin-top: 0;
  min-width: 180px;
}

.results-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--accent);
}

.results-count {
  color: var(--accent);
  font-weight: normal;
  font-size: 1.2rem;
}

.bookkeepers-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.loading {
  text-align: center;
  padding: 3rem;
  color: var(--gray);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--light-gray);
  border-top: 4px solid var(--accent);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.no-results {
  text-align: center;
  padding: 3rem;
  color: var(--gray);
  background: var(--light-bg);
  border-radius: 8px;
}

.no-results h3 {
  color: var(--primary);
  margin-bottom: 1rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .listing .form-row {
    flex-direction: column;
    gap: 1rem;
  }
  
  .listing .form-row .form-group {
    width: 100%;
  }
  
  .listing .submit-btn {
    width: 100%;
    min-width: auto;
  }
  
  .bookkeepers-list {
    grid-template-columns: 1fr;
  }
  
  .listing .hero-section h1 {
    font-size: 2rem;
  }
  
  .zip-search-form {
    padding: 1.5rem;
    margin-bottom: 2rem;
  }
}
/* === ICADLA PROMOTIONAL STYLES === */

/* ICADLA Page */
.icadla-page {
  background: linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%);
  min-height: 100vh;
}

/* Promotional Hero */
.promo-hero {
  padding: 4rem 0;
  text-align: center;
  color: var(--white);
}

.promo-content h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.promo-subtitle {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #ffd700;
}

.promo-description {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.promo-badges {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.badge {
  background: rgba(255, 255, 255, 0.2);
  color: var(--white);
  padding: 0.5rem 1rem;
  border-radius: 25px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  font-weight: 500;
}

/* Registration Options */
.registration-options {
  padding: 4rem 0;
  background: var(--white);
}

.registration-options h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  color: var(--primary);
}

.options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.option-card {
  background: var(--light-bg);
  padding: 3rem 2rem;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 3px solid transparent;
}

.option-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.15);
}

.bookkeeper-option:hover {
  border-color: var(--accent);
}

.requester-option:hover {
  border-color: #e74c3c;
}

.option-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.option-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--primary);
}

.option-card p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  color: var(--gray);
  line-height: 1.6;
}

.benefits-list {
  text-align: left;
  margin-bottom: 2rem;
  list-style: none;
  padding: 0;
}

.benefits-list li {
  margin-bottom: 0.5rem;
  color: var(--success);
  font-weight: 500;
  padding-left: 0;
}

.option-btn {
  display: inline-block;
  padding: 1rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: center;
}

.bookkeeper-btn {
  background: var(--accent);
  color: var(--white);
}

.bookkeeper-btn:hover {
  background: #4a9c7a;
  color: var(--white);
}

.requester-btn {
  background: #e74c3c;
  color: var(--white);
}

.requester-btn:hover {
  background: #c0392b;
  color: var(--white);
}

/* Promotional Info */
.promo-info {
  padding: 4rem 0;
  background: var(--light-bg);
}

.promo-info h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  color: var(--primary);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.info-item {
  background: var(--white);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  text-align: center;
}

.info-item h4 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: var(--primary);
}

.info-item p {
  color: var(--gray);
  line-height: 1.6;
}

/* ICADLA Registration Forms */
.icadla-register {
  background: linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%);
  min-height: 100vh;
  padding: 2rem 0;
}

.promo-header {
  text-align: center;
  color: var(--white);
  margin-bottom: 2rem;
}

.back-link {
  color: var(--white);
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  opacity: 0.9;
}

.back-link:hover {
  opacity: 1;
  color: var(--white);
}

.promo-header h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.promo-notice {
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
}

.icadla-form {
  background: var(--white);
  border-radius: 12px;
  padding: 3rem;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  max-width: 800px;
  margin: 0 auto;
}

.form-section {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 2px solid var(--border);
}

.form-section:last-of-type {
  border-bottom: none;
}

.form-section h3 {
  color: var(--primary);
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  border-left: 4px solid var(--accent);
  padding-left: 1rem;
}

.holiday-btn {
  width: 100%;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, var(--accent), #4a9c7a);
  color: var(--white);
  border: none;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.holiday-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(98, 181, 143, 0.3);
}

.holiday-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.requester-btn {
  background: linear-gradient(135deg, #e74c3c, #c0392b) !important;
}

.requester-btn:hover:not(:disabled) {
  box-shadow: 0 10px 20px rgba(231, 76, 60, 0.3) !important;
}

.promo-benefits {
  background: var(--light-bg);
  padding: 2rem;
  border-radius: 8px;
  margin: 2rem 0;
}

.promo-benefits h3 {
  color: var(--accent);
  margin-bottom: 1rem;
}

.promo-benefits ul {
  list-style: none;
  padding: 0;
}

.promo-benefits li {
  padding: 0.5rem 0;
  color: var(--primary);
  font-weight: 500;
}

.privacy-notice {
  text-align: center;
  color: var(--gray);
  font-size: 0.9rem;
  margin-top: 1rem;
}

/* Responsive Design for ICADLA */
@media (max-width: 768px) {
  .promo-content h1 {
    font-size: 2rem;
  }
  
  .options-grid {
    grid-template-columns: 1fr;
  }
  
  .option-card {
    padding: 2rem 1rem;
  }
  
  .icadla-form {
    padding: 2rem 1rem;
    margin: 0 1rem;
  }
  
  .promo-header h1 {
    font-size: 2rem;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
}
/* Add these styles to your existing CSS */
.input-with-symbol {
  position: relative;
  display: flex;
  align-items: center;
}

.currency-symbol {
  position: absolute;
  left: 12px;
  color: #666;
  font-weight: bold;
  z-index: 1;
}

.input-with-symbol input {
  padding-left: 25px;
}

.character-count {
  font-size: 0.8em;
  margin-left: 8px;
  font-weight: normal;
}

.character-count.valid {
  color: #28a745;
}

.character-count.invalid {
  color: #dc3545;
}

.error-text {
  color: #dc3545;
  font-size: 0.8em;
  margin-top: 4px;
  display: block;
}

.registration-form h3 {
  margin: 2rem 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e9ecef;
  color: #495057;
}
.loading {
  text-align: center;
  padding: 2rem;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #1976d2;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.no-results {
  text-align: center;
  padding: 3rem 2rem;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 2rem 0;
}

.no-results-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.help-section {
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #e9ecef;
}

.help-steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 1.5rem;
}

.step {
  text-align: center;
  padding: 1.5rem;
}

.step-number {
  background: #1976d2;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-weight: bold;
}

.results-header {
  margin-bottom: 2rem;
  text-align: center;
}

.results-subtitle {
  color: #666;
  font-style: italic;
  margin-top: 0.5rem;
}
.bookkeeper-card {
  background: var(--white);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--border);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.bookkeeper-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent) 0%, #4a9c7a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  font-weight: bold;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.name-section {
  flex: 1 1;
}

.full-name {
  color: var(--primary);
  margin: 0 0 0.25rem 0;
  font-size: 1.3rem;
  font-weight: 600;
}

.company-name {
  color: var(--accent);
  margin: 0;
  font-weight: 500;
  font-size: 1rem;
}

.card-body {
  flex: 1 1;
  margin-bottom: 1.5rem;
}

.info-row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
  color: var(--gray);
}

.info-row svg {
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.company-address {
  line-height: 1.4;
}

.contact-info {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--light-gray);
}

.contact-label {
  font-size: 0.85rem;
  color: var(--gray);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.contact-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--light-bg);
  border-radius: 8px;
  text-decoration: none;
  color: var(--primary);
  font-weight: 500;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.contact-link:hover {
  background: var(--accent);
  color: var(--white);
  transform: translateY(-1px);
}

.email-link:hover {
  box-shadow: 0 4px 12px rgba(98, 181, 143, 0.3);
}

.phone-link:hover {
  box-shadow: 0 4px 12px rgba(55, 51, 52, 0.3);
}

.contact-fallback {
  color: var(--gray);
  font-style: italic;
  padding: 0.5rem 0;
}

.card-footer {
  margin-top: auto;
}

.contact-badge {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  background: var(--light-bg);
  color: var(--primary);
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

@media (max-width: 768px) {
  .bookkeeper-card {
    padding: 1.25rem;
  }

  .card-header {
    gap: 0.75rem;
  }

  .avatar {
    width: 45px;
    height: 45px;
    font-size: 1.1rem;
  }

  .full-name {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,kBAAkB,OAAO,mCAAmC;EAC5D,iBAAiB,QAAQ,wCAAwC;EACjE,mBAAmB,MAAM,qBAAqB;EAC9C,gBAAgB,SAAS,eAAe;EACxC,eAAe,UAAU,gBAAgB;EACzC,qBAAqB,IAAI,eAAe;EACxC,iBAAiB,QAAQ,iBAAiB;EAC1C,gBAAgB,SAAS,mBAAmB;EAC5C,kBAAkB,OAAO,sBAAsB;AACjD;;AAEA,kBAAkB;AAClB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,0EAA0E;EAC1E,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,gCAAgC;EAChC,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB,EAAE,uDAAuD;EAC5E,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;AACjC;;AAEA,WAAW;AACX;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,eAAe;AACjB;;AAEA,mCAAmC;;AAEnC,yBAAyB;AACzB;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,oEAAoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;EACE,mEAAmE;EACnE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;;;;;;;;EAQE,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,uCAAuC;EACvC,qDAAqD;EACrD,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA,WAAW;EACX;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA,kBAAkB;EAClB;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;;IAIE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,2DAA2D;IAC3D,WAAW;EACb;;EAEA,UAAU;EACV;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA,gCAAgC;;AAEhC;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY,EAAE,wBAAwB;AACxC;;AAEA;EACE,YAAY,EAAE,uBAAuB;EACrC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA,sCAAsC;;AAEtC,gBAAgB;AAChB;EACE,0EAA0E;EAC1E,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,qDAAqD;EACrD,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,0EAA0E;EAC1E,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2DAA2D;EAC3D,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;AACA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mEAAmE;EACnE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Root Variables - Your Color Scheme */\n:root {\n  --primary: #373334;      /* Dark tone for text/backgrounds */\n  --accent: #62b58f;       /* Green accent for buttons/highlights */\n  --light-bg: #f8f9fa;     /* Light background */\n  --white: #ffffff;        /* Pure white */\n  --gray: #6c757d;         /* Medium gray */\n  --light-gray: #e9ecef;   /* Light gray */\n  --border: #dee2e6;       /* Border color */\n  --error: #dc3545;        /* Red for errors */\n  --success: #28a745;      /* Green for success */\n}\n\n/* Global Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Montserrat', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.6;\n  color: var(--primary);\n  background-color: var(--white);\n  min-height: 100vh;\n}\n\n/* Container */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Header */\n.header {\n  background-color: var(--primary);\n  padding: 1rem 0;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.header .container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logo a {\n  color: var(--accent);\n  font-size: 1.8rem;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.nav {\n  display: flex;\n  gap: 2rem;\n}\n\n.nav a {\n  color: var(--white); /* Ensure nav text is white for visibility on dark bg */\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.nav a:hover,\n.nav a.active {\n  color: var(--accent);\n}\n\n.nav-link {\n  color: var(--white);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.nav-link:hover,\n.nav-link.active {\n  color: var(--accent);\n}\n\n.menu-toggle {\n  display: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--white);\n  font-size: 1.5rem;\n}\n\n/* Main Content */\n.main-content {\n  min-height: calc(100vh - 140px);\n}\n\n/* Footer */\n.footer {\n  background-color: var(--primary);\n  color: var(--white);\n  text-align: center;\n  padding: 1.5rem 0;\n  margin-top: 2rem;\n}\n\n/* Pages */\n.page {\n  padding: 2rem 0;\n}\n\n/* === HOME PAGE ENHANCEMENTS === */\n\n/* Base Section Styling */\n.home-page section {\n  padding: 5rem 0;\n  position: relative;\n}\n\n/* Alternating Background Colors */\n.home-page .hero {\n  background: linear-gradient(to right, var(--primary), var(--accent));\n  color: var(--white);\n  text-align: center;\n}\n\n.home-page .services,\n.home-page .testimonials,\n.home-page .comparison,\n.home-page .trust {\n  background-color: var(--white);\n}\n\n.home-page .why-choose,\n.home-page .how-works,\n.home-page .integrations,\n.home-page .faq {\n  background-color: var(--light-bg);\n}\n\n.home-page .cta {\n  background: linear-gradient(135deg, var(--accent) 0%, #4a9c7a 100%);\n  color: var(--white);\n  text-align: center;\n}\n\n/* Section Borders */\n.home-page .services,\n.home-page .why-choose,\n.home-page .how-works,\n.home-page .testimonials,\n.home-page .faq,\n.home-page .comparison,\n.home-page .integrations,\n.home-page .trust {\n  border-bottom: 1px solid rgba(0,0,0,0.08);\n}\n\n/* Hero Section */\n.hero-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.hero-content h1 {\n  font-size: 3rem;\n  margin-bottom: 1.5rem;\n  font-weight: 700;\n}\n\n.hero-content p {\n  font-size: 1.3rem;\n  margin-bottom: 2rem;\n  opacity: 0.9;\n}\n\n.hero-image {\n  max-width: 600px;\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  margin: 2rem auto;\n  box-shadow: 0 20px 40px rgba(0,0,0,0.1);\n}\n\n/* Services Grid */\n.services .grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.service-item {\n  text-align: center;\n  padding: 2rem 1.5rem;\n  background: var(--white);\n  border-radius: 12px;\n  box-shadow: 0 5px 20px rgba(0,0,0,0.08);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid rgba(0,0,0,0.05);\n}\n\n.service-item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 30px rgba(0,0,0,0.15);\n}\n\n.service-item svg {\n  margin-bottom: 1rem;\n}\n\n.service-item h3 {\n  color: var(--primary);\n  font-size: 1.2rem;\n  margin-bottom: 1rem;\n}\n\n.service-item p {\n  color: var(--gray);\n  line-height: 1.6;\n}\n\n/* Why Choose Grid */\n.why-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2.5rem;\n  margin-top: 3rem;\n}\n\n.why-item {\n  text-align: center;\n  padding: 2rem;\n}\n\n.why-item svg {\n  margin-bottom: 1.5rem;\n}\n\n.why-item h3 {\n  color: var(--primary);\n  margin-bottom: 1rem;\n  font-size: 1.3rem;\n}\n\n.why-item p {\n  color: var(--gray);\n  line-height: 1.6;\n}\n\n/* How It Works Steps */\n.steps {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 3rem;\n  margin-top: 3rem;\n}\n\n.step {\n  text-align: center;\n  position: relative;\n}\n\n.step span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  background: var(--accent);\n  color: var(--white);\n  border-radius: 50%;\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-bottom: 1.5rem;\n}\n\n.step h3 {\n  color: var(--primary);\n  margin-bottom: 1rem;\n  font-size: 1.3rem;\n}\n\n.step p {\n  color: var(--gray);\n  line-height: 1.6;\n}\n\n/* Testimonials */\n.testimonial-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.quote {\n  background: var(--white);\n  padding: 2rem;\n  border-radius: 12px;\n  border-left: 4px solid var(--accent);\n  box-shadow: 0 5px 20px rgba(0,0,0,0.08);\n  font-style: italic;\n  color: var(--primary);\n  line-height: 1.6;\n}\n\n/* FAQ */\n.faq-item {\n  background: var(--white);\n  margin-bottom: 1rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.faq-item:hover {\n  border-color: var(--accent);\n}\n\n.faq-item h3 {\n  padding: 1.5rem;\n  margin: 0;\n  color: var(--primary);\n  font-size: 1.1rem;\n  position: relative;\n}\n\n.faq-item h3::after {\n  content: '+';\n  position: absolute;\n  right: 1.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.5rem;\n  color: var(--accent);\n}\n\n.faq-item p {\n  padding: 0 1.5rem 1.5rem;\n  margin: 0;\n  color: var(--gray);\n  line-height: 1.6;\n  border-top: 1px solid var(--border);\n  padding-top: 1rem;\n}\n\n/* Comparison Table */\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 2rem;\n  background: var(--white);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 5px 20px rgba(0,0,0,0.08);\n}\n\nth, td {\n  padding: 1.2rem 1.5rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border);\n}\n\nth {\n  background: var(--accent);\n  color: var(--white);\n  font-weight: 600;\n}\n\ntr:last-child td {\n  border-bottom: none;\n}\n\n/* Integrations & Trust */\n.logo-grid, .badge-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n  align-items: center;\n}\n\n.partner-logo {\n  max-width: 120px;\n  height: auto;\n  opacity: 0.8;\n  transition: opacity 0.3s ease;\n  justify-self: center;\n}\n\n.partner-logo:hover {\n  opacity: 1;\n}\n\n/* CTA Section */\n.cta-button {\n  display: inline-block;\n  background: var(--white);\n  color: var(--accent);\n  padding: 1rem 2.5rem;\n  border-radius: 8px;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 1.1rem;\n  margin-top: 2rem;\n  transition: all 0.3s ease;\n  box-shadow: 0 5px 15px rgba(0,0,0,0.2);\n}\n\n.cta-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0,0,0,0.3);\n}\n\n/* Forms */\n.zip-search-form, .state-zip-search-form {\n  max-width: 600px;\n  margin: 0 auto 2rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.form-group input, .form-group textarea, .form-group select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-size: 1rem;\n  background: var(--white);\n  box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n}\n\n.form-group input:focus, .form-group textarea:focus, .form-group select:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(98, 181, 143, 0.2);\n}\n\n.form-group label {\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  display: block;\n  color: var(--primary);\n}\n\n.zip-input {\n  text-align: center;\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.radio-group {\n  display: flex;\n  gap: 2rem;\n  margin-top: 0.5rem;\n}\n\n.radio-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  background: var(--light-bg);\n  padding: 0.75rem 1.5rem;\n  border-radius: 5px;\n  transition: background 0.3s;\n}\n\n.radio-label:hover {\n  background: rgba(98,181,143,0.1);\n}\n\n.search-btn, .submit-btn {\n  background-color: var(--accent);\n  color: var(--white);\n  border: none;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  width: 100%;\n  margin-top: 1rem;\n}\n\n.search-btn:hover, .submit-btn:hover {\n  background-color: #4a9c7a;\n}\n\n.search-btn:disabled, .submit-btn:disabled {\n  background-color: var(--gray);\n  cursor: not-allowed;\n}\n\n/* Bookkeeper Cards */\n.bookkeeper-card {\n  background: var(--white);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  border: 1px solid var(--border);\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.bookkeeper-card h3 {\n  color: var(--primary);\n  margin-bottom: 1rem;\n}\n\n.bookkeeper-card p {\n  margin-bottom: 0.5rem;\n}\n\n.preferred-contact {\n  padding-top: 0.5rem;\n  border-top: 1px solid var(--light-gray);\n  margin-top: 0.5rem;\n}\n\n/* Contact Form */\n.contact-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  align-items: start;\n}\n\n.contact-info h2 {\n  margin-bottom: 1rem;\n  color: var(--primary);\n}\n\n/* Messages */\n.submit-message {\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1.5rem;\n  font-weight: 600;\n}\n\n.submit-message.success {\n  background-color: #d4edda;\n  color: var(--success);\n  border: 1px solid #c3e6cb;\n}\n\n.submit-message.error {\n  background-color: #f8d7da;\n  color: var(--error);\n  border: 1px solid #f5c6cb;\n}\n\n.loading {\n  text-align: center;\n  padding: 2rem;\n  font-size: 1.1rem;\n  color: var(--gray);\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: var(--error);\n  padding: 1rem;\n  border-radius: 4px;\n  margin: 1rem 0;\n  border: 1px solid #f5c6cb;\n}\n\n.no-results {\n  text-align: center;\n  padding: 3rem;\n  color: var(--gray);\n}\n\n/* State Zip Search Form */\n.zip-group {\n  margin-bottom: 2rem;\n}\n\n.zip-header {\n  background-color: var(--accent);\n  color: var(--white);\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n.bookkeepers-in-zip {\n  display: grid;\n  gap: 1rem;\n}\n\n/* Section Headers */\n.services h2, .why-choose h2, .how-works h2, .testimonials h2, .faq h2, .comparison h2, .integrations h2, .trust h2, .cta h2 {\n  font-size: 2.5rem;\n  color: var(--primary);\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.cta h2 {\n  color: var(--white);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    padding: 15px;\n  }\n\n  /* Header */\n  .nav {\n    display: none;\n    flex-direction: column;\n    position: absolute;\n    top: 60px;\n    left: 0;\n    width: 100%;\n    background-color: var(--primary);\n    padding: 20px;\n    gap: 1rem;\n  }\n  \n  .nav.open {\n    display: flex;\n  }\n  \n  .menu-toggle {\n    display: block;\n  }\n\n  .header .container {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  /* Home Sections */\n  .home-page section {\n    padding: 3rem 0;\n  }\n  \n  .hero-content h1 {\n    font-size: 2.2rem;\n  }\n  \n  .services .grid,\n  .why-grid,\n  .steps,\n  .testimonial-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  \n  .logo-grid, .badge-grid {\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    gap: 1.5rem;\n  }\n\n  /* Forms */\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .form-group input, .form-group textarea, .form-group select {\n    font-size: 1.1rem;\n    padding: 1.2rem;\n  }\n  \n  .submit-btn, .search-btn {\n    padding: 1.2rem;\n    font-size: 1.1rem;\n  }\n  \n  .radio-group {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .contact-content {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (min-width: 769px) {\n  .menu-toggle {\n    display: none;\n  }\n}\n/* === LISTING PAGE STYLES === */\n\n.listing .hero-section {\n  text-align: center;\n  padding: 2rem 0 3rem;\n}\n\n.listing .hero-section h1 {\n  color: var(--primary);\n  margin-bottom: 1rem;\n  font-size: 2.5rem;\n}\n\n.listing .hero-subtitle {\n  font-size: 1.2rem;\n  color: var(--gray);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.zip-search-form {\n  max-width: 600px;\n  margin: 0 auto 3rem;\n  padding: 2rem;\n  background: var(--light-bg);\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.listing .form-row {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-end;\n}\n\n.listing .form-row .form-group {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.listing .zip-input {\n  text-align: center;\n  font-size: 1.2rem;\n  font-weight: bold;\n  height: 54px; /* Match button height */\n}\n\n.listing .submit-btn {\n  height: 54px; /* Match input height */\n  white-space: nowrap;\n  margin-top: 0;\n  min-width: 180px;\n}\n\n.results-header {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid var(--accent);\n}\n\n.results-count {\n  color: var(--accent);\n  font-weight: normal;\n  font-size: 1.2rem;\n}\n\n.bookkeepers-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 1.5rem;\n  margin-top: 2rem;\n}\n\n.loading {\n  text-align: center;\n  padding: 3rem;\n  color: var(--gray);\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--light-gray);\n  border-top: 4px solid var(--accent);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.no-results {\n  text-align: center;\n  padding: 3rem;\n  color: var(--gray);\n  background: var(--light-bg);\n  border-radius: 8px;\n}\n\n.no-results h3 {\n  color: var(--primary);\n  margin-bottom: 1rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .listing .form-row {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .listing .form-row .form-group {\n    width: 100%;\n  }\n  \n  .listing .submit-btn {\n    width: 100%;\n    min-width: auto;\n  }\n  \n  .bookkeepers-list {\n    grid-template-columns: 1fr;\n  }\n  \n  .listing .hero-section h1 {\n    font-size: 2rem;\n  }\n  \n  .zip-search-form {\n    padding: 1.5rem;\n    margin-bottom: 2rem;\n  }\n}\n/* === ICADLA PROMOTIONAL STYLES === */\n\n/* ICADLA Page */\n.icadla-page {\n  background: linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%);\n  min-height: 100vh;\n}\n\n/* Promotional Hero */\n.promo-hero {\n  padding: 4rem 0;\n  text-align: center;\n  color: var(--white);\n}\n\n.promo-content h1 {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  font-weight: 700;\n}\n\n.promo-subtitle {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: #ffd700;\n}\n\n.promo-description {\n  font-size: 1.2rem;\n  margin-bottom: 2rem;\n  opacity: 0.9;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.promo-badges {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.badge {\n  background: rgba(255, 255, 255, 0.2);\n  color: var(--white);\n  padding: 0.5rem 1rem;\n  border-radius: 25px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  font-weight: 500;\n}\n\n/* Registration Options */\n.registration-options {\n  padding: 4rem 0;\n  background: var(--white);\n}\n\n.registration-options h2 {\n  text-align: center;\n  font-size: 2.5rem;\n  margin-bottom: 3rem;\n  color: var(--primary);\n}\n\n.options-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 2rem;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.option-card {\n  background: var(--light-bg);\n  padding: 3rem 2rem;\n  border-radius: 15px;\n  text-align: center;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 3px solid transparent;\n}\n\n.option-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 20px 40px rgba(0,0,0,0.15);\n}\n\n.bookkeeper-option:hover {\n  border-color: var(--accent);\n}\n\n.requester-option:hover {\n  border-color: #e74c3c;\n}\n\n.option-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n}\n\n.option-card h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: var(--primary);\n}\n\n.option-card p {\n  font-size: 1.1rem;\n  margin-bottom: 2rem;\n  color: var(--gray);\n  line-height: 1.6;\n}\n\n.benefits-list {\n  text-align: left;\n  margin-bottom: 2rem;\n  list-style: none;\n  padding: 0;\n}\n\n.benefits-list li {\n  margin-bottom: 0.5rem;\n  color: var(--success);\n  font-weight: 500;\n  padding-left: 0;\n}\n\n.option-btn {\n  display: inline-block;\n  padding: 1rem 2rem;\n  border-radius: 8px;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 1.1rem;\n  transition: all 0.3s ease;\n  border: none;\n  cursor: pointer;\n  width: 100%;\n  text-align: center;\n}\n\n.bookkeeper-btn {\n  background: var(--accent);\n  color: var(--white);\n}\n\n.bookkeeper-btn:hover {\n  background: #4a9c7a;\n  color: var(--white);\n}\n\n.requester-btn {\n  background: #e74c3c;\n  color: var(--white);\n}\n\n.requester-btn:hover {\n  background: #c0392b;\n  color: var(--white);\n}\n\n/* Promotional Info */\n.promo-info {\n  padding: 4rem 0;\n  background: var(--light-bg);\n}\n\n.promo-info h2 {\n  text-align: center;\n  font-size: 2.5rem;\n  margin-bottom: 3rem;\n  color: var(--primary);\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.info-item {\n  background: var(--white);\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0,0,0,0.1);\n  text-align: center;\n}\n\n.info-item h4 {\n  font-size: 1.3rem;\n  margin-bottom: 1rem;\n  color: var(--primary);\n}\n\n.info-item p {\n  color: var(--gray);\n  line-height: 1.6;\n}\n\n/* ICADLA Registration Forms */\n.icadla-register {\n  background: linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%);\n  min-height: 100vh;\n  padding: 2rem 0;\n}\n\n.promo-header {\n  text-align: center;\n  color: var(--white);\n  margin-bottom: 2rem;\n}\n\n.back-link {\n  color: var(--white);\n  text-decoration: none;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  opacity: 0.9;\n}\n\n.back-link:hover {\n  opacity: 1;\n  color: var(--white);\n}\n\n.promo-header h1 {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n}\n\n.promo-notice {\n  font-size: 1.2rem;\n  opacity: 0.9;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.icadla-form {\n  background: var(--white);\n  border-radius: 12px;\n  padding: 3rem;\n  box-shadow: 0 20px 40px rgba(0,0,0,0.1);\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.form-section {\n  margin-bottom: 2rem;\n  padding-bottom: 2rem;\n  border-bottom: 2px solid var(--border);\n}\n\n.form-section:last-of-type {\n  border-bottom: none;\n}\n\n.form-section h3 {\n  color: var(--primary);\n  margin-bottom: 1.5rem;\n  font-size: 1.5rem;\n  border-left: 4px solid var(--accent);\n  padding-left: 1rem;\n}\n\n.holiday-btn {\n  width: 100%;\n  padding: 1rem 2rem;\n  background: linear-gradient(135deg, var(--accent), #4a9c7a);\n  color: var(--white);\n  border: none;\n  border-radius: 8px;\n  font-size: 1.2rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n}\n\n.holiday-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(98, 181, 143, 0.3);\n}\n\n.holiday-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.requester-btn {\n  background: linear-gradient(135deg, #e74c3c, #c0392b) !important;\n}\n\n.requester-btn:hover:not(:disabled) {\n  box-shadow: 0 10px 20px rgba(231, 76, 60, 0.3) !important;\n}\n\n.promo-benefits {\n  background: var(--light-bg);\n  padding: 2rem;\n  border-radius: 8px;\n  margin: 2rem 0;\n}\n\n.promo-benefits h3 {\n  color: var(--accent);\n  margin-bottom: 1rem;\n}\n\n.promo-benefits ul {\n  list-style: none;\n  padding: 0;\n}\n\n.promo-benefits li {\n  padding: 0.5rem 0;\n  color: var(--primary);\n  font-weight: 500;\n}\n\n.privacy-notice {\n  text-align: center;\n  color: var(--gray);\n  font-size: 0.9rem;\n  margin-top: 1rem;\n}\n\n/* Responsive Design for ICADLA */\n@media (max-width: 768px) {\n  .promo-content h1 {\n    font-size: 2rem;\n  }\n  \n  .options-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .option-card {\n    padding: 2rem 1rem;\n  }\n  \n  .icadla-form {\n    padding: 2rem 1rem;\n    margin: 0 1rem;\n  }\n  \n  .promo-header h1 {\n    font-size: 2rem;\n  }\n  \n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n}\n/* Add these styles to your existing CSS */\n.input-with-symbol {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.currency-symbol {\n  position: absolute;\n  left: 12px;\n  color: #666;\n  font-weight: bold;\n  z-index: 1;\n}\n\n.input-with-symbol input {\n  padding-left: 25px;\n}\n\n.character-count {\n  font-size: 0.8em;\n  margin-left: 8px;\n  font-weight: normal;\n}\n\n.character-count.valid {\n  color: #28a745;\n}\n\n.character-count.invalid {\n  color: #dc3545;\n}\n\n.error-text {\n  color: #dc3545;\n  font-size: 0.8em;\n  margin-top: 4px;\n  display: block;\n}\n\n.registration-form h3 {\n  margin: 2rem 0 1rem 0;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #e9ecef;\n  color: #495057;\n}\n.loading {\n  text-align: center;\n  padding: 2rem;\n}\n\n.spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #1976d2;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 2s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.no-results {\n  text-align: center;\n  padding: 3rem 2rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  margin: 2rem 0;\n}\n\n.no-results-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.help-section {\n  margin-top: 3rem;\n  padding-top: 2rem;\n  border-top: 1px solid #e9ecef;\n}\n\n.help-steps {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  margin-top: 1.5rem;\n}\n\n.step {\n  text-align: center;\n  padding: 1.5rem;\n}\n\n.step-number {\n  background: #1976d2;\n  color: white;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1rem;\n  font-weight: bold;\n}\n\n.results-header {\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.results-subtitle {\n  color: #666;\n  font-style: italic;\n  margin-top: 0.5rem;\n}\n.bookkeeper-card {\n  background: var(--white);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  border: 1px solid var(--border);\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.bookkeeper-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n.card-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--accent) 0%, #4a9c7a 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white);\n  font-weight: bold;\n  font-size: 1.2rem;\n  flex-shrink: 0;\n}\n\n.name-section {\n  flex: 1;\n}\n\n.full-name {\n  color: var(--primary);\n  margin: 0 0 0.25rem 0;\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n.company-name {\n  color: var(--accent);\n  margin: 0;\n  font-weight: 500;\n  font-size: 1rem;\n}\n\n.card-body {\n  flex: 1;\n  margin-bottom: 1.5rem;\n}\n\n.info-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  color: var(--gray);\n}\n\n.info-row svg {\n  flex-shrink: 0;\n  margin-top: 0.1rem;\n}\n\n.company-address {\n  line-height: 1.4;\n}\n\n.contact-info {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--light-gray);\n}\n\n.contact-label {\n  font-size: 0.85rem;\n  color: var(--gray);\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.contact-link {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: var(--light-bg);\n  border-radius: 8px;\n  text-decoration: none;\n  color: var(--primary);\n  font-weight: 500;\n  transition: all 0.3s ease;\n  border: 1px solid transparent;\n}\n\n.contact-link:hover {\n  background: var(--accent);\n  color: var(--white);\n  transform: translateY(-1px);\n}\n\n.email-link:hover {\n  box-shadow: 0 4px 12px rgba(98, 181, 143, 0.3);\n}\n\n.phone-link:hover {\n  box-shadow: 0 4px 12px rgba(55, 51, 52, 0.3);\n}\n\n.contact-fallback {\n  color: var(--gray);\n  font-style: italic;\n  padding: 0.5rem 0;\n}\n\n.card-footer {\n  margin-top: auto;\n}\n\n.contact-badge {\n  display: inline-block;\n  padding: 0.35rem 0.75rem;\n  background: var(--light-bg);\n  color: var(--primary);\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n@media (max-width: 768px) {\n  .bookkeeper-card {\n    padding: 1.25rem;\n  }\n\n  .card-header {\n    gap: 0.75rem;\n  }\n\n  .avatar {\n    width: 45px;\n    height: 45px;\n    font-size: 1.1rem;\n  }\n\n  .full-name {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
